import { render } from "./WhatsNewModal.vue?vue&type=template&id=d6495892&scoped=true"
import script from "./WhatsNewModal.vue?vue&type=script&lang=js"
export * from "./WhatsNewModal.vue?vue&type=script&lang=js"

import "./WhatsNewModal.vue?vue&type=style&index=0&id=d6495892&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6495892"]])

export default __exports__